/** The app's entry. ⚠ Deliberately thin: everything the drafter sees is the lifted chrome, and
 *  the canvas it wraps is Phase 2. */
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App";

createRoot(document.getElementById("root")!).render(
  <StrictMode><App /></StrictMode>);
